import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class SuKienCongToService {
  constructor(public api: ApiService) { }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy thống kê sự kiện công tơ theo danhmucid
  public get_All_SuKien(mataikhoan, danhmucid, ngay) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAYDS_SUKIENCONGTO" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_DATE: ngay,
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy các loại sự kiện công tơ
  public get_Type_SuKien() {
    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAY_TYPE_SUKIENCONGTO" }),
      para: JSON.stringify({
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy thống kê chi tiết sự kiện công tơ
  public get_ALL_Detail_SuKien(mataikhoan, danhmucid, type, datefrom, dateto, sotrang, sodong) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAYDS_SUKIENCONGTO_DETAIL" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_TYPE: type,
        v_DATEFROM: datefrom,
        v_DATETO: dateto,
        v_sotrang: sotrang,
        v_sodong: sodong,
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  //Lấy thống kê chi tiết sự kiện công tơ
  public get_ALL_Detail_SuKien_By_MetterID(meterid, mataikhoan, danhmucid, type, datefrom, dateto, sotrang, sodong) {

    var param = {

      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_SKCTO_DETAIL_BY_METTERID" }),
      para: JSON.stringify({
        v_METTERID: meterid,
        v_MATAIKHOAN: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_TYPE: type,
        v_DATEFROM: datefrom,
        v_DATETO: dateto,
        v_sotrang: sotrang,
        v_sodong: sodong,
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  //Xuất excel chi tiết
  get_EXCEL_detail(mataikhoan, danhmucid, type, datefrom, dateto, sotrang, sodong, tenDanhmuc, filename) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "right" },
      { "name": "event", "label": "Sự kiện", "horizontalalignment": "left" },
      { "name": "phase", "label": "Pha", "horizontalalignment": "left" },
      { "name": "timemin", "label": "Thời gian bắt đầu cảnh báo", "horizontalalignment": "center" },
      { "name": "timemax", "label": "Cảnh báo gần nhất", "horizontalalignment": "center" },
      { "name": "solan", "label": "Số lần cảnh báo", "horizontalalignment": "right" },
      { "name": "donvi", "label": "Đơn vị", "horizontalalignment": "left" },
    ]

    //let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAYDS_SUKIENCONGTO_DETAIL" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_TYPE: type,
        v_DATEFROM: datefrom,
        v_DATETO: dateto,
        v_sotrang: sotrang,
        v_sodong: sodong,
      }),
      title: "Chi tiết cảnh báo sự kiện công tơ",
      header: "Đơn vị: " + tenDanhmuc + " - Ngày: " + datefrom + "-" + dateto,
      filename: filename,
      sheets: 'Chi tiết cảnh báo sự kiện công tơ',
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, filename);
  }


  get_EXCEL_CLDN(mataikhoan, danhmucid, type, datefrom, dateto, sotrang, sodong, tenDanhmuc, filename) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "right" },
      { "name": "event", "label": "Sự kiện", "horizontalalignment": "left" },
      { "name": "phase", "label": "Pha", "horizontalalignment": "left" },
      { "name": "timemin", "label": "Thời gian bắt đầu cảnh báo", "horizontalalignment": "center" },
      { "name": "timemax", "label": "Cảnh báo gần nhất", "horizontalalignment": "center" },
      { "name": "solan", "label": "Số lần cảnh báo", "horizontalalignment": "right" },
      { "name": "donvi", "label": "Đơn vị", "horizontalalignment": "left" },
    ]

    //let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAYDS_SUKIENCONGTO_DETAIL" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_TYPE: type,
        v_DATEFROM: datefrom,
        v_DATETO: dateto,
        v_sotrang: sotrang,
        v_sodong: sodong,
      }),
      title: "Báo cáo chất lượng điện năng",
      header: "Đơn vị: " + tenDanhmuc + " - Ngày: " + datefrom + "-" + dateto,
      filename: filename,
      sheets: 'Báo cáo chất lượng điện năng',
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, filename);
  }

  save_EXCEL_CLDN(mataikhoan, danhmucid, type, datefrom, dateto, sotrang, sodong, tenDanhmuc, filename) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "right" },
      { "name": "event", "label": "Sự kiện", "horizontalalignment": "left" },
      { "name": "phase", "label": "Pha", "horizontalalignment": "left" },
      { "name": "timemin", "label": "Thời gian bắt đầu cảnh báo", "horizontalalignment": "center" },
      { "name": "timemax", "label": "Cảnh báo gần nhất", "horizontalalignment": "center" },
      { "name": "solan", "label": "Số lần cảnh báo", "horizontalalignment": "right" },
      { "name": "donvi", "label": "Đơn vị", "horizontalalignment": "left" },
    ]

    //let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAYDS_SUKIENCONGTO_DETAIL" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_TYPE: type,
        v_DATEFROM: datefrom,
        v_DATETO: dateto,
        v_sotrang: sotrang,
        v_sodong: sodong,
      }),
      title: "Báo cáo chất lượng điện năng",
      header: "Đơn vị: " + tenDanhmuc + " - Ngày: " + datefrom + "-" + dateto,
      filename: filename,
      sheets: 'Báo cáo chất lượng điện năng',
      columns: cols,
      data: "",
      mataikhoan: mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 7,
      tenbaocao: "Báo cáo chất lượng điện năng",
    };
    return this.api.Excute("api/saveexcel", param, filename);
  }
  //Xuất excel thống kê
  get_EXCEL(mataikhoan, danhmucid, ngay, tenDanhmuc, filename) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tendanhmuc", "label": "Đơn vị", "horizontalalignment": "left" },
      { "name": "phasefail", "label": "Lỗi pha", "horizontalalignment": "right" },
      { "name": "powerfail", "label": "Lỗi nguồn", "horizontalalignment": "right" },
      { "name": "voltageimbalance", "label": "Mất cân bằng điện áp", "horizontalalignment": "right" },
      { "name": "reversepower", "label": "Phát ngược", "horizontalalignment": "right" },
      { "name": "prolog", "label": "Lập trình", "horizontalalignment": "right" },
      { "name": "timechange", "label": "Thay đổi thời gian", "horizontalalignment": "right" },
      { "name": "passchange", "label": "Thay đổi mật khẩu", "horizontalalignment": "right" },
    ]

    //let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_SUKIEN_CONGTO.P_LAYDS_SUKIENCONGTO" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_DATE: ngay,
      }),
      title: "THỐNG KÊ SỰ KIỆN CÔNG TƠ",
      header: "Đơn vị: " + tenDanhmuc + " - Ngày: " + ngay,
      filename: filename,
      sheets: 'Thống kê sự kiện công tơ',
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, filename);
  }
  // get_EXCEL(json: string, filename: string, tablename: string, tableschema: string) {
  //   let formData: FormData = new FormData();
  //   formData.append('jsondata', json);
  //   formData.append('filename', filename);
  //   formData.append('tablename', tablename);
  //   formData.append('tableschema', tableschema);
  //   return this.api.downloadFile("api/ExportExcelSuKienCongTo/Json2ExcelFile", formData, filename);
  // }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/canh-bao/su-kien-cong-to/sukiencongto.service.ts